import ITranslation from "../../utils/types/translation";

const translationsNL: ITranslation = {
	Accessory: "Accessoires",
	AfterDossierCompletion: "Dossier volledig",
	AfterInstallation: "Te betalen na plaatsing",
	AfterMeasurement: "Na opmeting",
	AfterSales: "Na-Service",
	AfterSalesVPlan: "Na-Service vPlan",
	Appliance: "Electro",
	ArticleAccessory: "Artikel-Accessoires",
	ArticleAppliance: "Artikel-Elektro",
	ArticleFurniture: "Artikel-Meubelen",
	ArticleOther: "Artikel-Andere",
	ArticlePlumbing: "Artikel-Sanitair",
	ArticleWorktops: "Artikel-Werkbladen",
	AwaitingReminder: "Reminder te verzenden",
	Closed: "Afgewerkt",
	Communication: "Communicatie",
	Contacts: "Contacten",
	Delivered: "Geleverd",
	Delivery: "Levering",
	Deposit: "Voorschot",
	Documents: "Documenten",
	Email: "Email",
	Error: "Error",
	Furniture: "Meubelen",
	General: "Algemeen",
	Green: "Groen",
	Illness: "Ziekte",
	Installation: "Plaatsing",
	Invoicing: "Facturatie",
	New: "Nieuw",
	None: "Geen",
	NotApplicable: "N.A.",
	Now: "Nu",
	OnDelivery: "Te betalen bij levering",
	Orange: "Oranje",
	OrderExternal: "Bestel Extern",
	Ordered: "Besteld",
	OrderedProduction: "Besteld Productie",
	Other: "Andere",
	PhotosFilesVPlan: "Foto's-Bestanden vPlan",
	Picked: "Klaargezet",
	Plumbing: "Sanitair",
	ReadyForExecution: "Klaar voor uitvoering",
	Red: "Rood",
	ReminderError: "Reminder error",
	Sending: "Verzenden",
	SendingReminder: "Verzenden reminder",
	Sent: "Verzonden",
	Service: "Service",
	Vacation: "Vakantie",
	Vat0: "0%",
	Vat21: "21%",
	Vat6: "6%",
	Worktop: "Werkblad",
	Worktops: "Werkbladen",
	absenceReason: "Reden van afwezigheid",
	absent: "Afwezig",
	actions: "Acties",
	active: "Actief",
	add: "Toevoegen",
	addRemark: "Opmerking toevoegen",
	add_at_least_one: "Gelieve minstens 1 {{entity}} toe te voegen",
	address: "Adres",
	aftersales: "Na-service",
	amount: "€ Bedrag",
	amountExclVat: "€ Bedrag excl. BTW",
	amountInclVat: "€ Bedrag incl. BTW",
	article: "Artikel",
	articles: "Artikelen",
	ask_save: "Er zijn nog steeds niet opgeslagen wijzigingen. Wilt u deze opslaan?",
	assign: "Toewijzen",
	assignee: "Verantwoordelijke",
	back: "Terug",
	barcode: "Barcode (EAN of UPC)",
	binNumber: "Baknummer",
	body: "Body",
	brand: "Merk",
	brands: "Merken",
	by: "door",
	calendar: {
		today: "Vandaag"
	},
	cancel: "Annuleer",
	cancelling: "Annuleren",
	changeFutureTasks: "Verander toekomstige taken",
	changeFutureTasksQuestion: "Wilt u voor alle toekomstige taken de ploeg veranderen naar deze nieuwe ploeg?",
	checkDate: "Gecontroleerd",
	checkInAtWork: "CheckIN@Work",
	close: "Sluiten",
	closed: "Afgesloten",
	code: "Code",
	colleague: "Collega",
	color: "Kleur",
	communication: "Communicatie",
	communicationTemplates: "Communicatietemplates",
	communicationTemplatesSplitted: "Communicatie-templates",
	companies: "Bedrijven",
	company: "Bedrijf",
	complete: "Volledig",
	confirmChangeFixedDate: "Dit is een taak met vaste datum. Ben je zeker dat je deze wilt verplaatsen?",
	confirmDelivery: "Bent u zeker dat u 1 item van dit artikel op geleverd wil zetten?",
	confirmDeliveryTitle: "Bevestig levering",
	confirmLeave: "De data is niet opgeslagen, ben je zeker dat je dit scherm wil verlaten?",
	confirmPassonPickedDate: "Wenst u de datum door te zetten naar alle artikels?",
	confirm_content: "Bent u zeker dat u dit record wil {{action}}?",
	confirm_title: "Bevesting {{action}}",
	constructionYard: "Werf",
	constructionYardContact1: "Werf contact 1",
	constructionYardContact2: "Werf contact 2",
	constructionYards: "Werven",
	contactName: "Contactnaam",
	contactTypes: "Contacttypes",
	contacts: "Contacten",
	contractor: "Aannemer",
	contractors: "Aannemers",
	copy: "Kopiëer",
	copyDossier: "Kopiëer dossier",
	count: "Aantal",
	country: "Land",
	createNew: "Dit <1/> is niet gevonden.<3/>Wilt u een nieuw aanmaken?",
	createNewTask: "Maak nieuwe taak",
	createPurchaseOrders: "Aankooporders aanmaken",
	created: "Aangemaakt",
	createdBy: "Aangemaakt door",
	createdOn: "Aangemaakt op",
	cupboards: "Kasten",
	currentWeek: "Deze Week",
	customer: "Klant",
	customers: "Klanten",
	date: "Datum",
	dateinput: {
		increment: "Verhoog waarde",
		decrement: "Verlaag waarde"
	},
	datepicker: {
		toggleCalendar: "Toggle calendar"
	},
	day: "dag",
	deliverDate: "Geleverd",
	delivered: "Geleverd",
	deliveries: "Leveringen",
	deliveryDate: "Leverdatum",
	deliveryWeek: "Leverweek",
	depositAmountExclVat: "Bedrag voorschot excl. BTW",
	depositInvoiced: "Voorschot gefactureerd",
	depositPayed: "Voorschot betaald",
	description: "Beschrijving",
	details: "Details",
	discount: "Korting",
	displayedUsers: "Getoonde gebruikers",
	documents: "Documenten",
	dossier: "Dossier",
	dossierCannotBeDeleted: "Dit dossier kan niet worden verwijderd. Gelieve eerst de volgende items te verwijderen van dit dossier:",
	dossierContact1: "Dossier contact 1",
	dossierContact2: "Dossier contact 2",
	dossierCopied: "Dossier gekopiëerd",
	dossierDescription: "Dossier beschrijving",
	dossierManagement: "Dossierbeheer",
	dossierManager: "Dossierbeheerder",
	dossierMustBeComplete: "Het dossier moet volledig zijn voordat je dit kan doen.",
	dossierNumber: "Dossiernummer",
	dossierViewCheck: "Toon alleen dossiers met nog in te plannen taken.",
	downloadTradeplaceFile: "Download Tradeplace bestand",
	eanInformation: "EAN Informatie",
	edit: "Wijzigen",
	email: "Email",
	email1: "Email 1",
	email2: "Email 2",
	en: "Engels",
	error: "Error",
	errorInvoicing: "Facturatie error. Als 'Nu' geselecteerd is, moet je een bedrag groter dan nul ingeven.",
	errors: {
		server_error: "De server heeft een '{{statuscode}}' antwoord terug gestuurd.",
		error_duplicate: "Dit record bestaat al",
		error_dbconcurrency: "Dit record is in tussentijd gewijzigd of verwijderd door iemand anders. Gelieve te refreshen.",
		error_entityused: "Deze entiteit wordt nog steeds gebruikt binnen de applicatie. Als je deze niet wil zien in de schermen, gelieve deze dan te deactiveren.",
		error_constraintfailure: "Een database validatie regel is gefaald.",
		error_sqlconnection: "Er kan geen verbinding met de database gemaakt worden.",
		error_sqlgeneral: "Er is een database error gebeurd.",
		error_validation: "Er is een validatie error.",
		error_connection: "Er kan geen verbinding met een externe service gemaakt worden.",
		error_argumentnull: "Er was een leeg {{argument}} op de server",
		error_productwrongreplacement: "Een product kan niet zijn eigen vervanginsproduct zijn.",
		error_general: "Er is een error op de server gebeurd.",
		error_server_validation: "Servar validatie error.",
		error_idfilledin: "De ID kan niet ingevuld zijn als je een entiteit toevoegd",
		error_routeiddoesnotmatch: "De ID in de url-route komt niet overeen met de ID in the entiteit",
		error_idnotfilledin: "De ID moet meegegeven worden als je probeert te deleten",
		error_toomanyresults: "Teveel resultaten",
		error_nofile: "Geen file om te uploaden",
		error_nobarcodeorsearch: "Geen barcode of zoekterm meegegeven",
		error_constructionyardexistsbutnotactive: "Werf gevonden, maar deze is niet actief",
		not_authenticated: "Je bent niet ingelogd op de server",
		not_found: "De server heeft geen resultaat gevonden",
		forbidden: "Je hebt geen rechten op dit deel van de server"
	},
	estimatedSellerMargin: "Geschatte marge verkoper (%)",
	executedBy: "Uitgevoerd door",
	exportExcel: "Exporteer Excel",
	extraInfo: "Extra info",
	extraInformation: "Extra informatie",
	fetchEanInformation: "EAN informatie ophalen",
	file: "Bestand",
	fill_in_correct_date_values: "Gelieve juiste waarden in datum en tijd velden in te vullen. (Start > Stop)",
	fill_in_correct_format: "Gelieve een correcte waarde in het veld '{{field}}' in te vullen. Bvb: '{{example}}'.",
	fill_in_required_field: "Gelieve het verplicht veld '{{field}}' in te vullen.",
	fill_in_required_field_absent: "Gelieve een lead of collega in te vullen als afwezige",
	fill_in_required_field_absent_date: "Gelieve een start en stopdatum van afwezigheid in te vullen",
	fill_in_required_field_for_fixedDate: "Gelieve het veld '{{field}}' in te vullen om een vaste datum te selecteren.",
	fill_in_required_field_for_planned: "Gelieve het veld '{{field}}' in te vullen om een taak op gepland te zetten.",
	finished: "Afgewerkt",
	firstName: "Voornaam",
	firstOrderDate: "Eerste besteldatum",
	fixedDate: "Vaste datum",
	fixedDeliveryDate: "Vaste leverdatum",
	floor: "Verdieping",
	friday: "Vrijdag",
	fullDescriptionVat0: "Medecontractant - 0%",
	fullDescriptionVat21: "Nieuwbouw - 21%",
	fullDescriptionVat6: "Renovatie - 6%",
	fullName: "Volledige naam",
	gamma: "Gamma",
	general: "Algemeen",
	grid: {
		noRecords: "Geen data beschikbaar",
		groupPanelEmpty: "Sleep hier een kolom naar toe om erop te groeperen",
		filterClearButton: "Maak leeg",
		filterSubmitButton: "Filter",
		filterTitle: "Filter",
		sortAscending: "Sorteer Oplopend",
		sortDescending: "Sorteer Aflopend",
		pagerItemsPerPage: "items per pagina",
		pagerInfo: "{0} - {1} van {2} items",
		pagerFirstPage: "Ga naar de eerste pagina",
		pagerPreviousPage: "Ga naar de vorige pagina",
		pagerNextPage: "Ga naar de volgende pagina",
		pagerLastPage: "Ga naar de laatste pagina",
		pagerPage: "Pagina",
		pagerOf: "van",
		filterEqOperator: "Is gelijk aan",
		filterNotEqOperator: "Is niet gelijk aan",
		filterIsNullOperator: "Is null",
		filterIsNotNullOperator: "Is niet null",
		filterIsEmptyOperator: "Is leeg",
		filterIsNotEmptyOperator: "Is niet leeg",
		filterStartsWithOperator: "Begint met",
		filterContainsOperator: "Bevat",
		filterNotContainsOperator: "Bevat niet",
		filterEndsWithOperator: "Eindigt op",
		filterGteOperator: "Is groter dan of gelijk aan",
		filterGtOperator: "Is groter dat",
		filterLteOperator: "Is kleiner dan of gelijk aan",
		filterLtOperator: "Is kleiner dan",
		filterIsTrue: "Ja",
		filterIsFalse: "Nee",
		filterBooleanAll: "(Alles)",
		filterAfterOrEqualOperator: "Is na of gelijk aan",
		filterAfterOperator: "Is na",
		filterBeforeOperator: "Is voor",
		filterBeforeOrEqualOperator: "Is voor of gelijk aan",
		filterAndLogic: "En",
		filterOrLogic: "Of"
	},
	group: "Groep",
	hasSimpleAccess: "Simpele toegang?",
	help: "Help",
	home: "Startpagina",
	installationWeek: "Plaatsingsweek",
	installer: "Plaatser",
	invoiceDepositOn: "Voorschot te factureren op",
	invoiceSelected: "Factureer geselecteerde lijnen",
	invoiced: "Gefactureerd",
	invoicing: "Facturatie",
	isLiftNeeded: "Lift nodig?",
	labelPrinted: "Het printen van uw label is aangevraagd",
	labelsPrinted: "Het printen van uw labels is aangevraagd",
	language: "Taal",
	lastName: "Achternaam",
	lastUpdated: "Laatst gewijzigd",
	lastUploadedBy: "Laatst ge-upload door",
	lastUploadedDate: "Laatst ge-upload op",
	lead: "Lead",
	leadInstaller: "Lead plaatser",
	lineTotal: "Lijntotaal",
	lineTotalExcl: "excl. BTW (incl. korting)",
	lineTotalIncl: "incl. BTW (incl. korting)",
	lineTotalVat: "BTW € (incl. korting)",
	loggedBy: "Gelogd door",
	logout: "Uitloggen",
	manufacturer: "Producent",
	Margin: "Marge",
	marginStatus: "Marge status",
	MarginNotYetDeterminable: "Marge nog niet te bepalen",
	MarginToBeInvestigated: "Marge te onderzoeken",
	MarginValidated: "Marge gevalideerd",
	marginAfterAccountingAndValidation: "Marge na calculatie boekhouding/validatie (%)",
	marginAmountBasedOnAccounting: "Marge bedrag obv boekhouding (€)",
	masterData: "Masterdata",
	material: "Materiaal",
	measured: "Opgemeten",
	measurement: "Opmeting",
	modelNumber: "Model nummer",
	monday: "Maandag",
	month: "maand",
	multiviewcalendar: {
		prevView: "Navigeer naar vorige view",
		nextView: "Navigeer naar next view"
	},
	municipality: "Gemeente",
	name: "Naam",
	netPrice: "Nettoprijs",
	newDossierNumber: "Nieuw dossier nummer",
	next: "Volgende",
	nextWeek: "Volgende Week",
	nl: "Nederlands",
	no: "Nee",
	notFound: "{{entity}} niet gevonden",
	number: "Nummer",
	off: "Uit",
	ok: "Ok",
	on: "Aan",
	openServiceItems: "Openstaande na-service items",
	or: "of",
	orderDate: "Besteld",
	orderViaEMail: "Order via email",
	ourCustomerNumber: "Ons klant nummer",
	parking: "Parkeerplaats",
	passOnPickedDate: "Datum doorzetten",
	payed: "Betaald",
	pending_changes: "Wijzigingen",
	permission: "Permissie",
	permissions: {
		RolesRead: "Lezen",
		RolesAdd: "Toevoegen",
		RolesUpdate: "Wijzigen",
		RolesDelete: "Verwijderen",
		UsersRead: "Lezen",
		UsersAdd: "Toevoegen",
		UsersUpdate: "Wijzigen",
		UsersDelete: "Verwijderen",
		SuppliersRead: "Lezen",
		SuppliersAdd: "Toevoegen",
		SuppliersUpdate: "Wijzigen",
		SuppliersDelete: "Verwijderen",
		ProductsRead: "Lezen",
		ProductsAdd: "Toevoegen",
		ProductsUpdate: "Wijzigen",
		ProductsDelete: "Verwijderen",
		CustomersRead: "Lezen",
		CustomersAdd: "Toevoegen",
		CustomersUpdate: "Wijzigen",
		CustomersDelete: "Verwijderen",
		ContractorsRead: "Lezen",
		ContractorsAdd: "Toevoegen",
		ContractorsUpdate: "Wijzigen",
		ContractorsDelete: "Verwijderen",
		ConstructionYardsRead: "Lezen",
		ConstructionYardsAdd: "Toevoegen",
		ConstructionYardsUpdate: "Wijzigen",
		ConstructionYardsDelete: "Verwijderen",
		ProjectsRead: "Lezen",
		ProjectsAdd: "Toevoegen",
		ProjectsUpdate: "Wijzigen",
		ProjectsDelete: "Verwijderen",
		BrandsRead: "Lezen",
		BrandsAdd: "Toevoegen",
		BrandsUpdate: "Wijzigen",
		BrandsDelete: "Verwijderen",
		ProductTypesRead: "Lezen",
		ProductTypesAdd: "Toevoegen",
		ProductTypesUpdate: "Wijzigen",
		ProductTypesDelete: "Verwijderen",
		ShopsRead: "Lezen",
		ShopsAdd: "Toevoegen",
		ShopsUpdate: "Wijzigen",
		ShopsDelete: "Verwijderen",
		CommunicationTemplatesRead: "Lezen",
		CommunicationTemplatesAdd: "Toevoegen",
		CommunicationTemplatesUpdate: "Wijzigen",
		CommunicationTemplatesDelete: "Verwijderen",
		ContactTypesRead: "Lezen",
		ContactTypesAdd: "Toevoegen",
		ContactTypesUpdate: "Wijzigen",
		ContactTypesDelete: "Verwijderen",
		DossiersRead: "Lezen",
		DossiersAdd: "Toevoegen",
		DossiersUpdate: "Wijzigen",
		DossiersDelete: "Verwijderen",
		StockRead: "Lezen",
		StockAdd: "Toevoegen",
		ProcurementView: "Aankoopscherm",
		PlanningView: "Planningsscherm",
		WarehouseView: "Magazijnscherm",
		PrintLabels: "Toegestaan",
		InvoicingView: "Facturatiescherm",
		InvoicingMarginUpdate: "Marge wijzigen",
		InvoicingMarginView: "Marge bekijken",
		Settings: "Toegestaan",
		Home: "Toegestaan",
		TeamsRead: "Lezen",
		TeamsAdd: "Toevoegen",
		TeamsUpdate: "Wijzigen",
		TeamsDelete: "Verwijderen",
		SettingsRead: "Lezen",
		SettingsUpdate: "Wijzigen"
	},
	phone: "Telefoon",
	phone1: "Telefoon 1",
	phone2: "Telefoon 2",
	photos: "Foto's",
	pickDate: "Klaargezet",
	picked: "Klaargezet",
	pickedDateChanged: "Datum klaargezet is aangepast",
	pickings: "Klaarzetten",
	planned: "Gepland",
	planning: "Planning",
	planningManagementDelivery: "Planningbeheer - Levering",
	planningManagementInstallation: "Planningbeheer - Plaatsing",
	planningManagementService: "Planningbeheer - Service",
	pleaseSaveFirst: "Je kan deze actie enkel doen op opgeslagen dossiers.<1 />Gelieve eerst op te slaan.",
	please_calculate: "Gelieve nog de prijzen te berekenen",
	pokNumber: "POKNr.",
	postalCode: "Postcode",
	prevWeek: "Vorige Week",
	previous: "Vorige",
	print: "Print",
	printLabels: "Print labels",
	privacy: "Privacy",
	procurement: "Aankoop",
	product: "Product",
	productTypes: "Types",
	productionWeek: "Productieweek",
	products: "Producten",
	project: "Project",
	projects: "Projecten",
	province: "Provincie",
	purchasePriceExclVat: "€ Aankoopprijs/stuk excl. BTW",
	putArticleInStock: "Wilt u het verwijderde artikel in stock plaatsen?",
	readyForPicking: "Klaarzetten",
	related: "Gerelateerd",
	relatedToArticlePhase: "Artikel fase?",
	remark: "Opmerking",
	remarks: "Opmerkingen",
	reminderBody: "Reminder",
	reminderDate: "Reminder verzenden op",
	remove: "Verwijderen",
	replacementProduct: "Vervangingsproduct",
	replacement_product_cannot_be_the_same: "Het vervangingsproduct mag niet hetzelfde zijn.",
	resentOrderEmail: "Order mail opnieuw versturen",
	reset: "Resetten",
	role: "Rol",
	roles: "Rollen",
	runningDossiers: "Lopende dossiers",
	salesPrice: "Verkoopsprijs",
	salesPriceExclVat: "€ Verkoopsprijs excl. BTW",
	salesPriceInclVat: "€ Verkoopsprijs incl. BTW",
	salesRep: "Verkoper",
	saturday: "Zaterdag",
	save: "Opslaan",
	scanLocation: "Scan locatie",
	schedule: "Inplannen",
	searchByPok: "Zoek op POKnr",
	searchDossierNumber: "Zoek op dossiernummer",
	security: "Beveiliging",
	selectAll: "Selecteer alles",
	selectDossierMessage: "Selecteer een dossier om taken te zien.",
	select_at_least_one: "Gelieve minstens 1 {{entity}} te selecteren.",
	sellingDate: "Verkoopsdatum",
	sendToVPlan: "Verstuur naar vPlan",
	sequenceNumber: "Volgnummer",
	setPurchaseOrdersChecked: "Zet aankooporders gecontroleerd",
	settings: "Instellingen",
	shop: "Winkel",
	shops: "Winkels",
	show: "Toon",
	showCompletedTasks: "Toon afgewerkte taken",
	showNewDossier: "Wilt u naar het nieuwe dossier gaan?",
	soldOn: "Verkocht op",
	startDate: "Startdatum",
	startSequenceNumberDossier: "Start bij deze volgnummer bij nieuwe taak via planning",
	startTime: "Starttijd",
	status: "Status",
	stock: "Stock",
	stockMovement: "Stockbeweging",
	stopDate: "Stopdatum",
	stopTime: "Stoptijd",
	street: "Straat",
	subject: "Onderwerp",
	success: "Success",
	supplier: "Leverancier",
	suppliers: "Leveranciers",
	swap: "Wissel",
	switchcompany: "Wijzig bedrijf",
	task: "Taak",
	taskComplete: "Afgewerkt",
	taskDescription: "Taak beschrijving",
	taskPhotos: "Taak fotos",
	tasks: "Taken",
	team: "Ploeg",
	teams: "Ploegen",
	template: "Template",
	theseAreTheServerErrorMessages: "Dit zijn de server validatie errors:",
	thursday: "Donderdag",
	time: "Tijd",
	timepicker: {
		cancel: "Annuleer",
		now: "NU",
		selectNow: "Selecteer Nu",
		set: "Kies",
		toggleClock: "Wissel klok",
		toggleTimeSelector: "Open/sluit"
	},
	to: "Aan",
	toBeAsked: "Nog te bevragen",
	todaysTasks: "Taken voor vandaag",
	totalExclVat: "Totaal excl. BTW: € ",
	totalInclVat: "Totaal incl. BTW: € ",
	totalVat: "Totaal BTW: € ",
	tuesday: "Dinsdag",
	type: "Type",
	unable_to_display: "Het is onmogelijk om dit bestand te visualiseren.<1/>Download <3>hier</3>.",
	unit: "Unit",
	unitPrice: "Stukprijs",
	upload: {
		cancel: "Annuleer",
		clearSelectedFiles: "Maak leeg",
		dropFilesHere: "Bestanden hier neerzetten om te uploaden",
		headerStatusUploaded: "Klaar",
		headerStatusUploading: "Uploaden...",
		invalidFileExtension: "Bestandstype is niet toegestaan.",
		invalidFiles: "Invalid file(s). Please check file upload requirements.",
		invalidMaxFileSize: "Bestand is te groot.",
		invalidMinFileSize: "Bestand is te klein.",
		remove: "Verwijder",
		retry: "Probeer opnieuw",
		select: "Selecteer bestanden...",
		uploadSelectedFiles: "Upload",
		total: "Totaal",
		files: "bestanden"
	},
	user: "Gebruiker",
	users: "Gebruikers",
	vat: "BTW",
	vatNumber: "BTW nummer",
	vatOnDeposit: "BTW% op voorschot",
	warehouse: "Magazijn",
	wednesday: "Woensdag",
	welcome_message: "Welkom ",
	work: "Werk",
	writeOut: "Uitschrijving",
	writtenOut: "Uitgeschreven",
	year: "jaar",
	yes: "Ja",
	yourProfile: "Jouw profiel",
	yourRemarks: "Jouw opmerkingen",
	siteManager: "Werfleider",
	typeDossierSale: "Type dossier sales",
	typeDossierProduction: "Type dossier productie",
	complexityScore: "Complexiteit werkvoorbereiding",
	studioScore: "Atelier elementen",
	PlasticMaterialStock : "K1: Kunstof materiaal stock",
    NonStockInCatalog : "K2: Non-stock in catalogus",
    NonStockNotInCatalog : "K3: Non-stock niet in catalogus",
    Veneer : "K4: Fineer (enkel vernis)",
    Solid : "K5: Massief",
    LacquerIntern : "K6: Lak intern",
    LacquerExtern : "K7: Lak extern",
    ShowroomKitchen : "K8: Specials (inc. Toonzaalkeuken)",
	NewBuildAppartments : "T1: Nieuwbouw appartmenten",
    NewBuildHouseContractor : "T2: Nieuwbouw woning aannemer",
    PrivateIndividualsNewBuild : "T3: Particulieren nieuwbouw",
    PrivateIndividualsRenovation : "T4: Particulieren Technieken niet bevestigd (elke keuken vanaf 25k valt hier ook onder)",
    Specials : "T5: Specials (incl. grote dossiers, toonzaalkeukens en alles met extra werken, niet montage kasten)",
    ServiceAppliances2People : "T6: Service & toestellen - 2 personen",
    ServiceAppliances1Person : "T7: Service & toestellen - 1 persoon",
	PickupShowroom: "T8: Afhaal toonzaal",
	MeasuredDuringSurvey : "S-O: op stock, gemeten bij de opmeting",
    MeasuredDuringSurveyInAbsentia : "S-O-PL: op stock, gemeten bij de opmeting, in verstek",
    MeasuredAfterInstallation : "S-NP: op stock, gemeten na plaatsing",
    MeasuredAfterInstallationInAbsentia : "S-NP-PL: op stock, gemeten na plaatsing, in verstek",
    MeasuredDuringSurveyNotInStock : "N-O: niet op stock, gemeten bij de opmeting",
    MeasuredDuringSurveyNotInStockInAbsentia : "N-O-PL: niet op stock, gemeten bij de opmeting, in verstek",
    MeasuredAfterInstallationNotInStock : "N-NP: niet op stock, gemeten na plaatsing",
    MeasuredAfterInstallationNotInStockInAbsentia : "N-NP-PL: niet op stock, gemeten na plaatsing, in verstek",
    MeasuredDuringSurveyExtern : "EX-O: extern aangekocht, gemeten bij de opmeting",
    MeasuredDuringSurveyExternInAbsentia : "EX-O-PL: extern aangekocht, gemeten bij de opmeting, in verstek",
    MeasuredAfterInstallationExtern : "EX-NP: extern aangekocht, gemeten na plaatsing",
    MeasuredAfterInstallationExternInAbsentia : "EX-NP-PL: extern aangekocht, gemeten na plaatsing, in verstek",
	stoneCategorization: "Categorisatie steen",
	lacqueringComponent: "Lakkerij-elementen",
	access: "Toegang"
};

export default translationsNL;
